//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// BalancerV2PriceProvider
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0x2F1aA93249bcc0DF7d89739F86308c7a270F5EEd)
 */
export const balancerV2PriceProviderAbi = [
  {
    type: 'constructor',
    inputs: [
      {
        name: '_priceProvidersRepository',
        internalType: 'contract IPriceProvidersRepository',
        type: 'address',
      },
      { name: '_vault', internalType: 'contract IVault', type: 'address' },
      { name: '_periodForAvgPrice', internalType: 'uint32', type: 'uint32' },
    ],
    stateMutability: 'nonpayable',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'period',
        internalType: 'uint32',
        type: 'uint32',
        indexed: false,
      },
    ],
    name: 'NewPeriod',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'ago', internalType: 'uint32', type: 'uint32', indexed: false },
    ],
    name: 'NewSecondsAgo',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'newPendingOwner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'OwnershipPending',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'newOwner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'OwnershipTransferred',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'asset',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'poolId',
        internalType: 'bytes32',
        type: 'bytes32',
        indexed: true,
      },
    ],
    name: 'PoolForAsset',
  },
  {
    type: 'function',
    inputs: [],
    name: 'acceptOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: '_asset', internalType: 'address', type: 'address' }],
    name: 'assetSupported',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: '', internalType: 'address', type: 'address' }],
    name: 'assetsPools',
    outputs: [
      { name: 'poolId', internalType: 'bytes32', type: 'bytes32' },
      { name: 'priceOracle', internalType: 'address', type: 'address' },
      { name: 'token0isAsset', internalType: 'bool', type: 'bool' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: '_period', internalType: 'uint32', type: 'uint32' }],
    name: 'changePeriodForAvgPrice',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: '_ago', internalType: 'uint32', type: 'uint32' }],
    name: 'changeSecondsAgo',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: '_period', internalType: 'uint32', type: 'uint32' },
      { name: '_ago', internalType: 'uint32', type: 'uint32' },
    ],
    name: 'changeSettings',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: '_poolId', internalType: 'bytes32', type: 'bytes32' }],
    name: 'getPoolQuoteLiquidity',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: '_asset', internalType: 'address', type: 'address' }],
    name: 'getPrice',
    outputs: [{ name: 'price', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'owner',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'pendingOwner',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'periodForAvgPrice',
    outputs: [{ name: '', internalType: 'uint32', type: 'uint32' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: '_asset', internalType: 'address', type: 'address' }],
    name: 'priceBufferReady',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'priceProviderPing',
    outputs: [{ name: '', internalType: 'bytes4', type: 'bytes4' }],
    stateMutability: 'pure',
  },
  {
    type: 'function',
    inputs: [],
    name: 'priceProvidersRepository',
    outputs: [
      {
        name: '',
        internalType: 'contract IPriceProvidersRepository',
        type: 'address',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'quoteToken',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'removePendingOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'renounceOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: '_poolId', internalType: 'bytes32', type: 'bytes32' }],
    name: 'resolvePoolAddress',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'pure',
  },
  {
    type: 'function',
    inputs: [],
    name: 'secondsAgo',
    outputs: [{ name: '', internalType: 'uint32', type: 'uint32' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '_asset', internalType: 'address', type: 'address' },
      { name: '_poolId', internalType: 'bytes32', type: 'bytes32' },
    ],
    name: 'setupAsset',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'newOwner', internalType: 'address', type: 'address' }],
    name: 'transferOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'newPendingOwner', internalType: 'address', type: 'address' },
    ],
    name: 'transferPendingOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'vault',
    outputs: [{ name: '', internalType: 'contract IVault', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '_poolId', internalType: 'bytes32', type: 'bytes32' },
      { name: '_asset', internalType: 'address', type: 'address' },
    ],
    name: 'verifyPool',
    outputs: [
      { name: 'tokens', internalType: 'contract IERC20[]', type: 'address[]' },
    ],
    stateMutability: 'view',
  },
] as const

/**
 * [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0x2F1aA93249bcc0DF7d89739F86308c7a270F5EEd)
 */
export const balancerV2PriceProviderAddress = {
  1: '0x2F1aA93249bcc0DF7d89739F86308c7a270F5EEd',
} as const

/**
 * [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0x2F1aA93249bcc0DF7d89739F86308c7a270F5EEd)
 */
export const balancerV2PriceProviderConfig = {
  address: balancerV2PriceProviderAddress,
  abi: balancerV2PriceProviderAbi,
} as const
